import React from 'react';
import { Stack, styled, Typography } from '@mui/material';
import { AutoStoriesOutlined } from '@mui/icons-material';

const AutoStoriesOutlinedIcon = styled(AutoStoriesOutlined)(({ theme }) => ({
  fontSize: theme.spacing(3),
}));

interface AssessmentsPageInfoProps {
  currentPage: number;
  totalPages: number;
}

export const AssessmentsPageInfo = ({ currentPage, totalPages }: AssessmentsPageInfoProps) => (
  <Stack direction="row" spacing={0.75}>
    <AutoStoriesOutlinedIcon />
    <Typography variant="body1" fontWeight={500} noWrap>
      Page {currentPage} of {totalPages}
    </Typography>
  </Stack>
);
